import type { PropsWithChildren } from 'react';

import './styles.scss';

interface Props {
    testId: string;
    padding?: boolean;
}

/**
 * @returns The main layout container that worps the app components
 */
export const Container = ({ children, testId, padding }: PropsWithChildren<Props>) => {
    const styles = { padding: padding ? 24 : 0 };

    return (
        <div className="main-container" data-testid={testId} style={styles}>
            {children}
        </div>
    );
};
